import { useState } from "react";
import arrowDown from "../assets/images/down.png";
import arrowUp from "../assets/images/arrow_up.png";

export const SelectWithRadio = ({
  data = [],
  placeholder = "",
  type = "",
  handleFilterChange,
  className = "w-280",
}) => {
  const [dropDown, setdropDown] = useState(false);
  const [arrowImage, setArrowImage] = useState(false);
  const [selected, setSelected] = useState(null);

  const handleCourseSelection = (item) => {
    setTimeout(() => {
      setdropDown(false);
      setArrowImage((prev) => !prev);
    }, 200);
    setSelected(item.label);
    handleFilterChange(item, type);
  };

  const Toggle = () => {
    setdropDown(!dropDown);
    setArrowImage(!arrowImage);
  };

  return (
    <div className="dropdown explore_btn">
      <div className="form-group" onClick={Toggle}>
        <div
          className={`book_shelf_drop_down drop-down-class ${className}`}
          style={{ height: "none" }}
        >
          <div className="d-flex justify-content-between select_class_parent w-100">
            <p className="f_12">{selected || placeholder}</p>
            <img
              className="toggle_class_sel_arrow"
              src={arrowImage ? arrowUp : arrowDown}
              alt="arrow"
            />
          </div>
        </div>
      </div>
      {dropDown ? (
        <div
          className="book_shelf_drop_down_options"
          onMouseLeave={() => setdropDown(false)}
        >
          <div>
            <ul>
              {data.map((el, index) => (
                <li key={index}>
                  <div className="iagree_radio radio_list">
                    <input
                      type="radio"
                      name="Due-next"
                      id={`option_${index}`}
                      checked={el.label === selected}
                      onChange={() => handleCourseSelection(el)}
                    />
                    <label
                      htmlFor={`option_${index}`}
                      className="drop_down_list"
                    >
                      {el.label}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ) : null}
    </div>
  );
};
